import {
    IRenouvellement,
    ISession,
    PageInitiale,
    ParcoursAssurance
} from '../../..';
import { isMockEnabled } from '../../../../api';
import { CodeAvisEnumModal } from '../../../../components';
import { getBaseLocationUrl, getEnvConfig } from '../../../../config';
import {
    getAuthorisationValeurHeader,
    getConfigCookie
} from '../../../../utils';
import { EMPRUNTEURS_ACTUEL_RAPPORT } from '../../apiEndPoints';

export interface IDiagnosticData {
    pageInitiale?: PageInitiale;
    codeAvis?: CodeAvisEnumModal | null;
    pretAdmissibleAssurance?: boolean;
    parcoursAssurance?: ParcoursAssurance;
    redirectUrl?: string;
    montantTotalInteretRetard?: number;
    isSignatureIntegre?: boolean;
}

export interface IDiagnostic {
    config: any;
    flowDesPages?: string[];
    session?: ISession;
    diagnosticData?: IDiagnosticData;
    errorUrl?: string;
    errorObject?: any;
    codeErreurRHN?: string;
    errorMessage?: string;
}

export function prepareDiagnosticData(
    session: ISession,
    renouvellement: IRenouvellement,
    flowData: string[],
    errorUrl: string,
    //eslint-disable-next-line
    errorObject: any,
    codeErreurRHN: string,
    errorMessage: string
): IDiagnostic {
    const diagnosticData: IDiagnosticData = {
        pageInitiale: renouvellement?.pageInitiale,
        codeAvis: renouvellement?.codeAvis,
        pretAdmissibleAssurance: renouvellement?.pretAdmissibleAssurance,
        parcoursAssurance: renouvellement?.parcoursAssurance,
        redirectUrl: renouvellement?.redirectUrl,
        montantTotalInteretRetard: renouvellement?.montantTotalInteretRetard,
        isSignatureIntegre: renouvellement?.isSignatureIntegre
    };

    return {
        config: encodeURI(getConfigCookie()),
        flowDesPages: flowData,
        session,
        diagnosticData,
        errorUrl,
        errorObject,
        codeErreurRHN,
        errorMessage
    };
}

export async function useRapportApi(
    diagnosticData: IDiagnostic
): Promise<void> {
    //Si les mock sont actifs ou que l'on a meme pas les donnees de session -> on skip l'appel
    if (
        isMockEnabled() ||
        !diagnosticData?.session ||
        !diagnosticData?.session?.contextePret?.idDemande
    ) {
        return;
    }
    const envConfig = getEnvConfig();
    const token = await getAuthorisationValeurHeader();
    // Fetch
    fetch(
        envConfig.baseApiUrl +
            EMPRUNTEURS_ACTUEL_RAPPORT +
            '?idDemande=' +
            diagnosticData?.session?.contextePret?.idDemande,
        {
            method: 'POST',
            cache: 'no-cache',
            credentials: 'include',
            headers: {
                'Access-Control-Allow-Origin': getBaseLocationUrl(),
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                Expires: '0',
                'x-desj-tenantId': 'auth0'
            },
            body: JSON.stringify(diagnosticData)
        }
    );
}
